import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import vuetify from '@/plugins/vuetify';
import type { ProformaCurrency, ProformaInfo, ProformaLine, ProformaWindow } from '@/types/ProformaTypes';
import type { ColumnDef } from '@/types/ColumnDef';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProformaExchangeRateGrid',
  props: {
    proformaId: null,
    currencies: null,
    userCanEdit: { type: Boolean },
    proformaLines: null,
    proformaInfo: null,
    localCurrency: null
  },
  emits: ["update:proformaWindow"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'update:proformaWindow',
    payload: {
      proformaLines: ProformaLine[];
      proformaInfo: ProformaInfo;
      currencies: ProformaCurrency[];
    }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  proformaId: number;
  currencies: ProformaCurrency[];
  userCanEdit: boolean;
  proformaLines: ProformaLine[];
  proformaInfo: ProformaInfo;
  localCurrency: string;
};





function emitUpdatedProforma(proformaWindow: ProformaWindow) {
  emit('update:proformaWindow', proformaWindow);
}

const exchangeRateColumns = computed(() => {
  const result: ColumnDef<ProformaCurrency>[] = [
    { header: 'USE', field: 'PER_SHOW', align: 'left', width: '50px' },
    { header: 'Currency', field: 'CURRENCY_NAME', dataType: 'string', width: '60px' },
    { header: 'Rate', field: 'RATE', dataType: 'number', align: 'left' },
    { header: 'Sum', field: 'SUM', dataType: 'number', decimals: 2 },
  ];
  return result;
});

function onExchangeRateCheckboxClicked(id: number, value: 0 | 1) {
  const currencies: ProformaCurrency[] = [...props.currencies];
  const currency = currencies.find((c) => c.PER_ID === id);
  if (currency) {
    currency.PER_SHOW = value;
    emitUpdatedProforma({ proformaLines: props.proformaLines, currencies, proformaInfo: props.proformaInfo });
  }
}

function onRateChange(inputValue: string, currency: ProformaCurrency) {
  const currencies: ProformaCurrency[] = [...props.currencies];
  /* const proformaLines = [...props.proformaLines]; */
  let value: number | undefined = parseFloat(inputValue.replace(',', '.'));
  if (Number.isNaN(value) || value === 0) {
    value = undefined;
  }
  if (value !== undefined && value !== currency.RATE) {
    const updatedCurrencies = currencies.map((c) => {
      if (c.PER_ID === currency.PER_ID) {
        return { ...c, RATE: Number(value) };
      }
      return c;
    });
    emitUpdatedProforma({
      proformaLines: props.proformaLines,
      currencies: updatedCurrencies,
      proformaInfo: props.proformaInfo,
    });
  }
}

function getSharedInputProps(label: string, showAsReadonly: boolean = false) {
  let backgroundColor: string | undefined;
  if (showAsReadonly) {
    backgroundColor = vuetify.framework.theme.dark ? 'grey darken-3' : 'grey lighten-4';
  }
  const hideDetails = true;
  const noflex = true;
  const dense = true;
  const disabled = showAsReadonly;
  return {
    backgroundColor,
    hideDetails,
    noflex,
    dense,
    solo: true,
    flat: true,
    outlined: false,
    disabled,
  };
}

return { __sfc: true,props, emit, emitUpdatedProforma, exchangeRateColumns, onExchangeRateCheckboxClicked, onRateChange, getSharedInputProps }
}

})